// @ts-nocheck
import React from 'react';
import { Input, Textarea, Grid, AtsTip, SectionCard, AddButton, FormNav } from '../FormField';
import { ATS_TIPS } from '../../data/initialData';

export default function ProjectsTab({ data, onChange, onBack, onNext }) {
  const update = (idx, key, val) => {
    const arr = [...data];
    arr[idx] = { ...arr[idx], [key]: val };
    onChange(arr);
  };

  const add = () =>
    onChange([
      ...data,
      { id: Date.now(), name: '', tech: '', link: '', github: '', description: '' },
    ]);

  const remove = (idx) => onChange(data.filter((_, i) => i !== idx));

  return (
    <div>

      {data.map((p, i) => (
        <SectionCard
          key={p.id}
          title="Project"
          index={i}
          showRemove={data.length > 1}
          onRemove={() => remove(i)}
        >
          <Grid cols={2}>
            <Input
              label="Project Name"
              required
              value={p.name}
              onChange={(v) => update(i, 'name', v)}
              placeholder="CodeSync"
            />
            <Input
              label="Technologies Used"
              value={p.tech}
              onChange={(v) => update(i, 'tech', v)}
              placeholder="Next.js, TypeScript, WebSockets, Redis, PostgreSQL, Docker"
            />
          </Grid>
          <Grid cols={2}>
            <Input
              label="GitHub Link"
              value={p.github}
              onChange={(v) => update(i, 'github', v)}
              placeholder="github.com/arjunsharma/codesync"
            />
            <Input
              label="Live Demo Link"
              value={p.link}
              onChange={(v) => update(i, 'link', v)}
              placeholder="codesync.dev"
            />
          </Grid>
          <Textarea
            label="Description"
            hint="problem → what you built → outcome/impact"
            value={p.description}
            onChange={(v) => update(i, 'description', v)}
            placeholder="Built a real-time collaborative code editor (VS Code-like) with multi-cursor editing, WebSocket-based CRDT conflict resolution, and integrated video calling. Supports 25+ languages via Monaco Editor and a code-execution sandbox powered by Docker. Handles 100+ concurrent users per room with sub-100ms sync latency. 1,500+ GitHub stars, 40+ contributors."
            rows={4}
          />
        </SectionCard>
      ))}

      <AddButton onClick={add} label="Add Another Project" />

      <FormNav showBack onBack={onBack} showNext onNext={onNext} nextLabel="Next: Skills →" />
    </div>
  );
}
